import $ from 'jquery';
import Menu from './Menu';
// import MobileMenu from './MenuCtrl';
import Quicklinks from './Quicklinks';

const URL = '//ischool.sjsu.edu';

export default class ExportMenu {
  constructor(element) {
    this.element = element;
    this.fail = this.fail.bind(this);
    this.success = this.success.bind(this);

    const url = new Request(URL);
    const options = {
      mode: 'cors',
      method: 'GET',
      cache: 'default',
    };

    // Request homepage.
    fetch(url, options)
      .then(this.validate)
      .then(this.success)
      .catch(this.fail);
  }

  // Validate response from our request.
  /* eslint-disable class-methods-use-this */
  validate(response) {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response.text();
  }

  // Display an error message if the request failed.
  fail(error) {
    this.error = error;
  }

  success(result) {
    const prependElements = {
      '.social-links': '.footer-cols-inner',
      '.footerlinks': '.footer-cols-inner',
    };

    const appendElements = {
      '.quicklinks': '#navigation',
      '.headerlinks': '#navigation',
      '#block-nice_menus-3': '#navigation',
    };

    this.prependElement(result, prependElements);
    this.appendElement(result, appendElements);
    this.mainNav();
  }

  mainNav() {
    // Add functionality to the menu.
    $('#block-nice_menus-3').each((i, element) => {
      if (!element.Menu && !element.MobileMenu) {
        element.Menu = new Menu(element);
        // element.MobileMenu = new MobileMenu(element);
      }
    });

    // Quicklinks navigation
    $('.quicklinks').each((i, element) => {
      if (!element.quicklinks) {
        element.quicklinks = new Quicklinks(element);
      }
    });
  }

  prependElement(result, elements) {
    $.each(elements, (i, val) => {
      const $content = $(result).find(i);
      this.setAbsolutePath($content);
      $content.prependTo(this.element.find(val));
    });
  }

  appendElement(result, elements) {
    $.each(elements, (i, val) => {
      const $content = $(result).find(i);
      this.setAbsolutePath($content);
      $content.appendTo(this.element.find(val));
    });
  }

  setAbsolutePath($content) {
    $content.find('a').filter('[href^="/"]').each((i, component) => {
      $(component).attr('href', (ii, value) => `${URL}${value}`);
    });
  }
}



// WEBPACK FOOTER //
// ./MenuExport.js